// extracted by mini-css-extract-plugin
module.exports = {"fontStyles":"common_fontStyles__dVXKd"};